import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlatformAdministrationService } from 'src/app/platform-administration/services/platform-administration.service';

@Injectable()
export class PlatformAdminOrServiceUserAuthGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly platformAdministrationService: PlatformAdministrationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return forkJoin({
      isAdministrator: this.platformAdministrationService.isUserPlatformAdministrator(),
      isServiceUser: this.platformAdministrationService.isUserServiceUser()
    }).pipe(
      map(({ isAdministrator, isServiceUser }) => {
        if (!isAdministrator && !isServiceUser) {
          sessionStorage.setItem('navigationFailed', 'platform');
          this.router.navigate(['organizations']);
          return false;
        }
        return true;
      })
    );
  }
}
